import React, { FC } from 'react';

import { FixedGridRowProps } from './FixedGrid.types';
import { getClassNames } from './FixedGridRow.styles';

/**
 * A `FixedGridRow` represents each row inside a `FixedGrid`. It should wrap `FixedGridColumn`s.
 * @deprecated Please use CoreUI's [Flex and FlexItem components](https://yammer-client-storybook.azurewebsites.net/yammer-web-core-ui/?path=/story/layout-flex--overview) instead.
 */

const FixedGridRow: FC<FixedGridRowProps> = ({ children, className, bottomSpacing, columnSpacing = 2 }) => {
  const { fixedGridRow } = getClassNames({ columnSpacing, bottomSpacing, className });

  return <div className={fixedGridRow}>{children}</div>;
};

export default FixedGridRow;
